import { brLine } from './br-line';
import { cleanHostname } from './clean-hostname';
import { wrapLines } from './wrap-lines';

const filters = {
  brLine,
  cleanHostname,
  wrapLines
};

export const init = vueInstance => {
  for (const key in filters) {
    vueInstance.filter(key, filters[key]);
  }
};
